import ZoomDelegate from '../common/ZoomDelegate';
import { CommandType } from '../constants/Constants';
import BaseCommand from './BaseCommand';
/**
 * 缩放命令
 *
 * @export
 * @class CmdUndo
 * @extends {BaseCommand}
 * @author zhenliang.sun
 */
export default class CmdZoom extends BaseCommand {
  constructor() {
    super();
    this.type = CommandType.Zoom;
    this.executing = false;

    let root = this.root;
    let opt = this.app.tools.zoomOption;
    // 初始化一个 缩放委托
    this.delegate = new ZoomDelegate(root, opt);
  }

  execute() {
    super.execute();
    this.delegate.start();
  }

  complete() {
    super.complete();
    this.delegate.stop();
  }
}
